import React, { FC } from 'react';

export const FontLink: FC = () => (
    <link
        href="https://fonts.googleapis.com/css?family=Open+Sans:400,400i,600|Poppins:300,600&display=swap"
        rel="stylesheet"
    />
);
